'use client';

const DedicatedCardProfile: React.FC = () => {
    return (
        <div className="flex-nowrap justify-start symbol-group symbol-hover mb-30">
            <div className="rounded-full border-2 symbol symbol-80px border-secondary symbol-jainam" title="Jaiinam Shahh">
                <picture>
                    <source media="(max-width: 767px)" srcSet="/img/avtar/img-jainam-shah.webp" />
                    <source media="(min-width: 768px)" srcSet="/img/avtar/img-jainam-shah-2x.webp" />
                    <img alt="Pic" height={80} width={80} src="/img/avtar/img-jainam-shah.webp" className="rounded-full img-fluid" loading="lazy" />
                </picture>
            </div>            
            <div className="rounded-full border-2 symbol symbol-80px border-secondary symbol-deep" title="Deep Trivedi">
                <picture>
                    <source media="(max-width: 767px)" srcSet="/img/avtar/img-deep-trivedi.webp" />
                    <source media="(min-width: 768px)" srcSet="/img/avtar/img-deep-trivedi-2x.webp" />
                    <img alt="Pic" height={80} width={80} src="/img/avtar/img-deep-trivedi.webp" className="rounded-full img-fluid" loading="lazy" />
                </picture>
            </div>
            <div className="rounded-full border-2 symbol symbol-80px border-secondary symbol-kaushal" title="Kaushal Panchal">
                <picture>
                    <source media="(max-width: 767px)" srcSet="/img/avtar/img-kaushal-panchal.webp" />
                    <source media="(min-width: 768px)" srcSet="/img/avtar/img-kaushal-panchal-2x.webp" />
                    <img alt="Pic" height={80} width={80} src="/img/avtar/img-kaushal-panchal.webp" className="rounded-full img-fluid" loading="lazy" />
                </picture>
            </div>
        </div>
    );
};

export default DedicatedCardProfile;
